import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import HttpStatus from 'ha/constants/HttpStatus';

const onEnterListYourPlace = store => ({ location }, replace) => {
  if (!getIsAuthenticated(store.getState())) {
    replace({
      ...location,
      pathname: '/become-an-advertiser',
      state: {
        redirectCode: HttpStatus.FOUND_REDIRECTION,
      },
    });
  }
};

export default onEnterListYourPlace;
